import { render, staticRenderFns } from "./downloadPage.vue?vue&type=template&id=ae9b3696&scoped=true"
import script from "./downloadPage.vue?vue&type=script&lang=js"
export * from "./downloadPage.vue?vue&type=script&lang=js"
import style0 from "./downloadPage.vue?vue&type=style&index=0&id=ae9b3696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9b3696",
  null
  
)

export default component.exports